import { Component, OnInit, Input } from '@angular/core';
import { ProcessoService } from '@app/services/processo.service';
import { ProcessoObservacao } from '@app/models/processo-observacao';

@Component({
  selector: 'app-mov-observacoes',
  templateUrl: './movimentacao-observacoes.component.html',
  styleUrls: ['./movimentacao-observacoes.component.scss']
})
export class ObservacaoMovimentacaoProcessoComponent implements OnInit {

  @Input() processoId: number;
  processoMovObservacao: ProcessoObservacao = new ProcessoObservacao();
  editando = false;
  mostrar = false;

  constructor(
    private processoService: ProcessoService,
  ) { }

  ngOnInit() {
    this.obterMovimentacaoObs();
  }

  obterMovimentacaoObs() {
    this.processoService.obterMovObservacao(this.processoId).subscribe(data => {
      this.processoMovObservacao.Observacao = data;
      this.processoMovObservacao.Id = this.processoId;
    });
  }

  gravarObs() {
    this.processoService.atualizarMovObservacao(this.processoMovObservacao).subscribe(() => this.editar());
  }

  editar() {
    this.editando = !this.editando;
  }

  cancelar() {
    this.editar();
    this.obterMovimentacaoObs();
  }

}
